export default function CTASection() {
  return (
    <section className="py-0 relative overflow-hidden">
      <div className="relative min-h-[600px] flex items-center">
        {/* Pure CSS gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0c18] via-[#0d1025] to-[#050810]"></div>
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#d4af37]/8 blur-[140px] pointer-events-none"></div>
        <div className="absolute bottom-0 left-1/4 w-[300px] h-[300px] rounded-full bg-[#1a2a5e]/20 blur-[100px] pointer-events-none"></div>
        <div className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: "linear-gradient(rgba(212,175,55,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,0.4) 1px, transparent 1px)",
            backgroundSize: "60px 60px"
          }}
        ></div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-24">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 mb-8">
              <i className="ri-rocket-line text-[#d4af37] text-sm"></i>
              <span className="text-[#d4af37] text-xs font-semibold tracking-widest uppercase">Let&apos;s Get Started</span>
            </div>

            <h2 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6">
              Ready to Grow<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060]">Your Business?</span>
            </h2>

            <p className="text-white/60 text-lg leading-relaxed mb-10 max-w-lg">
              A great website is the foundation of every successful business online. Let&apos;s build yours — modern, fast, and designed to bring you more clients.
            </p>



            <div className="flex flex-wrap items-center gap-6 mt-10 pt-10 border-t border-white/10">
              {[
                { icon: "ri-shield-check-line", label: "No commitment required" },
                { icon: "ri-star-line", label: "Premium quality work" },
                { icon: "ri-calendar-check-line", label: "Flexible scheduling" },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2 text-white/40 text-sm">
                  <i className={`${item.icon} text-[#d4af37]`}></i>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
